module.exports = __webpack_public_path__ + "img/GoldeneTangente.2ad8f3c9.jpg";